module.exports = __webpack_public_path__ + "img/logo_feat_software_whole.26097b15.png";